import { useState, useEffect } from 'react';

/**
 * Custom hook for tracking active heading on scroll
 * @param {Array} tableOfContents - Array of TOC items
 * @returns {string} Currently active heading ID
 */
export const useBlogScroll = (tableOfContents) => {
    const [activeHeading, setActiveHeading] = useState('');

    useEffect(() => {
        const handleScroll = () => {
            const headings = document.querySelectorAll('h2[id]');
            const scrollPosition = window.scrollY + 100; // Offset for better UX

            let currentHeading = '';
            
            // If we're at the top of the page, highlight the first heading
            if (scrollPosition < 200 && headings.length > 0) {
                currentHeading = headings[0].id;
            } else {
                // Find the last heading that has passed the scroll position
                for (let i = headings.length - 1; i >= 0; i--) {
                    const heading = headings[i];
                    const headingTop = heading.offsetTop;
                    
                    if (scrollPosition >= headingTop) {
                        currentHeading = heading.id;
                        break;
                    }
                }
            }

            setActiveHeading(currentHeading);
        };

        // Add scroll listener
        window.addEventListener('scroll', handleScroll);
        
        // Initial check
        handleScroll();

        // Cleanup
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [tableOfContents]);

    return activeHeading;
};
